import {Component, OnInit} from '@angular/core';
import {AppConfigService} from '../../../../../app-config.service';
import {GeneralService} from '../../../../service/general-service';
import {NzModalService} from 'ng-zorro-antd/modal';
import {TranslateService} from '@ngx-translate/core';
import {NotificationService} from '../../../../service/notification.service';
import {FormBuilder} from '@angular/forms';
import {ShareaService} from '../../../../service/sharea.service';
import {OrderService} from '../../../../service/order-service';

@Component({
  selector: 'app-doctor-patient',
  templateUrl: './doctor-patient.component.html',
  styleUrls: ['./doctor-patient.component.scss']
})
export class DoctorPatientComponent implements OnInit {
  datas: any[] = [];
  filter = {
    startDate: new Date(),
    endDate: new Date(),
    status: 'all'
  };
  isShowReport = false;
  files: any[] = [];
  constructor(
    private configService: AppConfigService,
    private generalService: GeneralService,
    public translate: TranslateService,
    private notificationService: NotificationService,
  ) {
    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);
    this.filter.startDate = sevenDaysAgo;
  }

  ngOnInit(): void {
    this.getListData();
  }

  getListData() {
    const payload = {
      page: 1,
      pageSize: 1000,
      fromDate: this.filter.startDate,
      toDate: this.filter.endDate,
      isResult: null
    };
    if (this.filter.status === 'all') {
      delete payload.isResult;
    } else {
      payload.isResult = this.filter.status === 'ready' ? true : false;
    }
    this.generalService.getPatient4Partner(payload).subscribe(
      (res) => {
        if (res !== null) {
          console.log(res);
          this.datas = res.data;
          this.datas.forEach(en => {
            en.isResultText = en.isValid ? (en.isResult ? 'Đủ KQ' : 'Chưa đủ KQ') : 'Chưa duyệt';
          });
        }
      },
      (error) => {
      }
    );
  }
  printReceipt(data = null) {
    console.log(data);
    const orderId = data.orderId;
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', this.configService.getConfig().api.viewerUrl.replace('Viewer.aspx','BridgeXLSDownload.aspx') + `?id=${orderId}&report=PhieuThuTienPartner`);
    document.body.appendChild(link);
    console.log('download-link', link);
    link.click();
    link.remove();
  }
  showDetail(item: any) {
    // console.log(item);
    // console.error(item);
    this.files = [];
    if (item.allFile.length > 1) {
      this.isShowReport = true;
      console.log(item.allFile);
      item.allFile.forEach(en => {
        en = en.replace('https://invivo.pmr.vn', this.configService.getConfig().api.baseUrl);
        console.log(en);
        const fileName = this.getFileNameFromUrl(en);
        const fileItem = {fileName, fileUrl: en};

        this.files.push(fileItem);
      });

    } else if (item.allFile.length === 1) {
      const url = item.allFile[0].replace('https://invivo.pmr.vn', this.configService.getConfig().api.baseUrl);
      window.open(url, '_blank'); // '_blank' opens in a new tab
    }
  }

  doFilter() {
    // console.log(this.filter);
    this.getListData();
  }

  handleRowDblClick($event: any) {
    const item = $event.data;
    if (item.isValid) {
      this.showDetail(item);
    }
  }

  closeModal() {
    this.isShowReport = false;
  }

  getFileNameFromUrl(url: any) {
    if (!url) {
      return '';
    }
    return url.split('/').pop();
  }
}
